import { WikiArticle, WikiArticleMain, WikiArticleSubPanel } from '../WikiArticle'
import { Heading, HStack, ListItem, Text, Link } from '@chakra-ui/react'
import { LinkToSection, SectionIndex, SectionTitle } from '../../../new_component/organisms/SectionIndex'
import CodeExample from '../../../new_component/organisms/CodeExample'

const JSLibrary = () => {
	return <WikiArticle>
		<WikiArticleMain>
			<section>
				<Heading as="h2">FQL Toolkit Library</Heading>
				<Text>
					A lightweight and flexible JavaScript toolkit library for Form Query Language (FQL) that provides a fluent API for building and executing FQL queries.
				</Text>
			</section>
			<section>
				<SectionTitle>
					Installation
				</SectionTitle>
				<Text>Using Node Package Manager (npm)</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					npm install fql-toolkit
				</CodeExample>
			</section>

			<section>
				<SectionTitle>
					Running Tests
				</SectionTitle>
				<Text>
					To run the tests just execute:
				</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					npm test
				</CodeExample>
			</section>

			<section>
				<SectionTitle>Initialization</SectionTitle>
				<Text>Initialize the FQL client with the API endpoint and token:</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					{`const fql = new FQL({
  url: 'https://api.example.com',
  token: 'FQL USER TOKEN HERE'
});`}
				</CodeExample>
			</section>

			<section>
				<SectionTitle>Creating Forms</SectionTitle>
				<Text>Create a new form with data definitions:</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					{`await fql.createForm('employees')
  .addDataDefinition({name: 'name', type: 'text'})
  .addDataDefinition({name: 'salary', type: 'number'})
  .execute();`}
				</CodeExample>
			</section>

			<section>
				<SectionTitle>Inserting Data</SectionTitle>
				<Text>Insert data into a form:</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					{`await fql.createNew('employees')
  .setValue('John Doe')
  .setValue(50000)
  .execute();`}
				</CodeExample>
			</section>

			<section>
				<SectionTitle>Showing Forms</SectionTitle>
				<Text>Retrieve all forms or specific forms:</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					{`// Show all forms
await fql.showForms().execute();

// Show a specific form
await fql.showForms().setForm('employees').execute();`}
				</CodeExample>
			</section>

			<section>
				<SectionTitle>Removing Forms</SectionTitle>
				<Text>Remove forms from the database:</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					{`await fql.removeForms()
  .setForm('employees')
  .execute();`}
				</CodeExample>
			</section>

			<section>
				<SectionTitle>Error Handling</SectionTitle>
				<Text>Handle errors gracefully:</Text>
				<CodeExample title={"JavaScript"} margin={0} run={false}>
					{`try {
  await fql.createData('employees')
    .setValue('John Doe')
    .setValue('invalid_salary') // Wrong type
    .execute();
} catch (error) {
  if (error instanceof FQLError) {
    console.error('FQL Error:', error.message);
  }
}`}
				</CodeExample>

				<HStack justifySelf={"flex-end"} mt={"10px"} alignItems={"flex-start"}>
					<Text>Read more in </Text>
					<Link
						href="https://www.npmjs.com/package/fql-toolkit"
						target="_blank"
						color={"brand.500"}
						fontWeight={"700"}
					>
						nmpjs.com
					</Link>
				</HStack>
			</section>
		</WikiArticleMain >

		<WikiArticleSubPanel>
			<SectionIndex>
				<ListItem><LinkToSection>Installation</LinkToSection></ListItem>
				<ListItem><LinkToSection>Running Tests</LinkToSection></ListItem>
				<ListItem><LinkToSection>Initialization</LinkToSection></ListItem>
				<ListItem><LinkToSection>Creating Forms</LinkToSection></ListItem>
				<ListItem><LinkToSection>Inserting Data</LinkToSection></ListItem>
				<ListItem><LinkToSection>Showing Forms</LinkToSection></ListItem>
				<ListItem><LinkToSection>Removing Forms</LinkToSection></ListItem>
				<ListItem><LinkToSection>Error Handling</LinkToSection></ListItem>
			</SectionIndex>
		</WikiArticleSubPanel>
	</WikiArticle >
}

export default JSLibrary